import React from "react";
import { RECIPIENT_META, STATUS_KEYS, STATUS_META } from "../../utils/constants";
import SignaturePad from "./SignaturePad";

/* Step 4 — staff assignment, status and the two signatures. */
export default function StepApproval({ form, update, recipientTypes, active }) {
  return (
    <div className={`wizard-step-panel ${active ? "active" : ""}`} id="step-panel-4">
      <div className="panel-section-title">
        <span className="section-badge">4</span> Approval, Staff Assignment &amp; Signatures
      </div>

      <div className="form-grid grid-2">
        <div className="form-group">
          <label htmlFor="input-prepared_by">Prepared By (Staff Name)</label>
          <input
            type="text"
            id="input-prepared_by"
            placeholder="e.g. John Doe / Account Manager"
            maxLength={255}
            value={form.prepared_by}
            onChange={(e) => update({ prepared_by: e.target.value })}
          />
        </div>
        <div className="form-group">
          <label htmlFor="input-assigned_to">Production / Assigned To</label>
          <input
            type="text"
            id="input-assigned_to"
            placeholder="e.g. Print Team / Studio B"
            maxLength={255}
            value={form.assigned_to}
            onChange={(e) => update({ assigned_to: e.target.value })}
          />
        </div>
      </div>

      <div className="form-group">
        <label htmlFor="input-status">
          Job Order Status <span className="req">*</span>
        </label>
        <select id="input-status" value={form.status} onChange={(e) => update({ status: e.target.value })}>
          {STATUS_KEYS.map((key) => (
            <option key={key} value={key}>
              {STATUS_META[key].option}
            </option>
          ))}
        </select>
      </div>

      <div className="form-grid grid-2 mt-3">
        <SignaturePad
          id="sig-customer"
          label="Customer Approval Signature"
          uploadedMessage="Customer signature image uploaded!"
          initialValue={form.customer_signature}
          onChange={(value) => update({ customer_signature: value })}
        >
          <div className="form-group mt-2">
            <label htmlFor="input-approval_date">Approval Date</label>
            <input type="date" id="input-approval_date" value={form.approval_date} onChange={(e) => update({ approval_date: e.target.value })} />
          </div>
        </SignaturePad>

        <SignaturePad
          id="sig-recipient"
          label="Delivery / Recipient Signature"
          uploadedMessage="Recipient signature image uploaded!"
          initialValue={form.recipient_signature}
          onChange={(value) => update({ recipient_signature: value })}
        >
          <div className="form-grid grid-2 mt-2">
            <div className="form-group">
              <label htmlFor="input-recipient_name">Received By</label>
              <input
                type="text"
                id="input-recipient_name"
                placeholder="Receiver full name"
                maxLength={255}
                value={form.recipient_name}
                onChange={(e) => update({ recipient_name: e.target.value })}
              />
            </div>
            <div className="form-group">
              <label htmlFor="input-recipient_type">Type</label>
              <select id="input-recipient_type" value={form.recipient_type} onChange={(e) => update({ recipient_type: e.target.value })}>
                {recipientTypes.map((type) => (
                  <option key={type} value={type}>
                    {RECIPIENT_META[type]?.option || type}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="form-group mt-2">
            <label htmlFor="input-recipient_date">Received Date</label>
            <input type="date" id="input-recipient_date" value={form.recipient_date} onChange={(e) => update({ recipient_date: e.target.value })} />
          </div>
        </SignaturePad>
      </div>
    </div>
  );
}
